<script>
import { filtersComputed, filtersMethods } from '@state/helpers'
// import toggle from '@utils/design/toggle-info'

export default {
  computed: {
    ...filtersComputed,
  },

  mounted: function() {
    const domain = 'meet.jit.si'
    const options = {
      roomName: 'JitsiMeetAPIExample',
      width: 289,
      height: 705,
      parentNode: document.querySelector('#meet'),
    }
    const api = new JitsiMeetExternalAPI(domain, options)
  },
  methods: {
    ...filtersMethods,

    selectDate: function(date) {},
  },
}
</script>

<template>
  <div id="meet"></div>
</template>

<style lang="scss"></style>
